import React, {useRef, useContext, useEffect} from 'react';
import FastForward from "./icons/fastForward";
import StepForward from "./icons/stepForward";
import {SheetContext} from "./sheetContext";

const TableNav = () => {
  const {parsedShowCells, tabletoolContainer, firstTr, activeSheet, showNav} = useContext(SheetContext)
  let position = useRef(parsedShowCells);
  let tableRow = Array.from(tabletoolContainer.querySelectorAll('tr'))

  if (position.current === parsedShowCells) {
    Array.from(tabletoolContainer.querySelectorAll('.prev-btn, .to-start-btn')).map(i => i.classList.add('inactive'))
  }

  let lastClass =  ".tt-col-" + (position.current);
  tableRow.map(i => i.querySelector(lastClass) && i.querySelector(lastClass).classList.add('last-visible-shadow'))

  // Move right
  const moveRight = () => {
    let parsedTdCount = firstTr.querySelectorAll("td").length
    if (parsedTdCount > parsedShowCells) {
      if (position.current === parsedTdCount - 2) {
        Array.from(tabletoolContainer.querySelectorAll('.next-btn, .to-end-btn')).map(i => i.classList.add('inactive'))
      }
      if (position.current !== parsedTdCount - 1) {
        Array.from(tabletoolContainer.querySelectorAll('.first-visible-shadow')).map(i => i.classList.remove('first-visible-shadow'))
        Array.from(tabletoolContainer.querySelectorAll('.last-visible-shadow')).map(i => i.classList.remove('last-visible-shadow'))

        let disableClass = ".tt-col-" + (position.current + 1);
        tableRow.map(i => i.querySelector(disableClass) && i.querySelector(disableClass).classList.remove('d-none'))
        tableRow.map(i => i.querySelector(disableClass) && i.querySelector(disableClass).classList.add('last-visible-shadow'))

        position.current = position.current + 1;
        let enableClass = ".tt-col-" + (position.current - parsedShowCells);
        let enableClass2 =  ".tt-col-" + (position.current - parsedShowCells + 1);

        tableRow.map(i => i.querySelector(enableClass) && i.querySelector(enableClass).classList.add('d-none'))
        tableRow.map(i => i.querySelector(enableClass2) && i.querySelector(enableClass2).classList.add('first-visible-shadow'))

        Array.from(tabletoolContainer.querySelectorAll('.prev-btn, .to-start-btn')).map(i => i.classList.remove('inactive'))
      }
      if (position.current + 1 === parsedTdCount) {
        Array.from(tabletoolContainer.querySelectorAll('.last-visible-shadow')).map(i => i.classList.remove('last-visible-shadow'))
      }
    }
  }

  // Move left
  const moveLeft = () => {
    if (position.current === parsedShowCells + 1) {
      Array.from(tabletoolContainer.querySelectorAll('.prev-btn, .to-start-btn')).map(i => i.classList.add('inactive'))
    }
    if (position.current !== parsedShowCells) {
      Array.from(tabletoolContainer.querySelectorAll('.first-visible-shadow')).map(i => i.classList.remove('first-visible-shadow'))
      Array.from(tabletoolContainer.querySelectorAll('.last-visible-shadow')).map(i => i.classList.remove('last-visible-shadow'))

      let disableClass = ".tt-col-" + position.current;
      let disableClass2 =  ".tt-col-" + (position.current -1);
      tableRow.map(i => i.querySelector(disableClass) && i.querySelector(disableClass).classList.add('d-none'))
      tableRow.map(i => i.querySelector(disableClass2) && i.querySelector(disableClass2).classList.add('last-visible-shadow'))

      let enableClass = ".tt-col-" + (position.current - parsedShowCells);
      tableRow.map(i => i.querySelector(enableClass) && i.querySelector(enableClass).classList.remove('d-none'))
      tableRow.map(i => i.querySelector(enableClass) && i.querySelector(enableClass).classList.add('first-visible-shadow'))

      position.current = position.current - 1;
      Array.from(tabletoolContainer.querySelectorAll('.next-btn, .to-end-btn')).map(i => i.classList.remove('inactive'))
    }
    if (position.current === parsedShowCells) {
      Array.from(tabletoolContainer.querySelectorAll('.first-visible-shadow')).map(i => i.classList.remove('first-visible-shadow'))
    }
  }

  // Move to right end
  const moveRightToEnd = () => {
    let parsedTdCount = firstTr.querySelectorAll("td").length
    let amount = parsedTdCount - position.current;
    for (var i=0; i<amount; i++) {
      moveRight();
    }
  }

  // Move to left end
  const moveLeftToEnd = () => {
    let amount = position.current - parsedShowCells;
    for (var i=0; i<amount; i++) {
      moveLeft();
    }
  }

  useEffect(() => {
    moveLeftToEnd()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSheet])

  return (
    <div className={`table-navigation ${showNav ? 'visible' : 'invisible'}`}>
      <button onClick={() => moveLeftToEnd()} className="to-start-btn border-0 d-flex align-items-center"><FastForward/></button>
      <button onClick={() => moveLeft()} className="prev-btn border-0 d-flex align-items-center"><StepForward/></button>
      <button onClick={() => moveRight()} className="next-btn border-0 d-flex align-items-center"><StepForward/></button>
      <button onClick={() => moveRightToEnd()} className="to-end-btn border-0 d-flex align-items-center"><FastForward/></button>
    </div>
  );
};

export default TableNav;
